import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { IntroductionPageTeaser } from 'cpie-common';
import { fetchIntroductionPageTeaser } from './IntroductionPageTeaserSlice';
import { IntroductionPageTeaserContentSelector } from './IntroductionPageTeaserContentSelector';

export function useIntroductionPageTeaser(): AbstractContentState<IntroductionPageTeaser> {
    return useCmsContent(fetchIntroductionPageTeaser, IntroductionPageTeaserContentSelector);
}
